import gql from 'graphql-tag'

import { SchoolFieldsFragment, SchoolWithDirectorFieldsFragment } from 'main/gql/school'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

export const CONTACT_SCHOOL_MODAL_QUERY = gql`
  query ContactSchoolModal($schoolId: Int!) {
    school(id: $schoolId) {
      ...SchoolFields
      ...SchoolWithDirectorFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${SchoolFieldsFragment}
  ${SchoolWithDirectorFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
